import React from 'react';
import Icon from '../../../components/AppIcon';

const MobileStats = ({ stablecoinValue, m2Value, ratio, lastUpdated }) => {
  const stats = [
    {
      id: 'stablecoin-market-cap',
      label: 'Total Stablecoin Market Cap',
      value: `$${(stablecoinValue / 1e9)?.toFixed(2)}B`,
      icon: 'CircleDollarSign',
      color: '#D08A2A',
      bgColor: 'bg-[#D08A2A]/10',
      description: 'Total stablecoins'
    },
    {
      id: 'm2-supply',
      label: 'US M2 Money Supply',
      value: `$${(m2Value / 1e12)?.toFixed(2)}T`,
      icon: 'Landmark',
      color: 'var(--color-muted-foreground)',
      bgColor: 'bg-muted',
      description: 'US money supply'
    },
    {
      id: 'ratio',
      label: 'Stablecoin/M2 Ratio',
      value: `${ratio?.toFixed(4)}%`,
      icon: 'Percent',
      color: 'var(--color-primary)',
      bgColor: 'bg-primary/10',
      description: 'Market penetration'
    }
  ];

  return (
    <div className="space-y-3 md:space-y-4">
      <div className="grid grid-cols-1 gap-3 md:gap-4">
        {stats?.map((stat) => (
          <div
            key={stat?.id}
            className="bg-card rounded-lg border border-border p-4 md:p-5 transition-all duration-300 active:scale-98"
          >
            <div className="flex items-center justify-between mb-2">
              <div className="flex items-center gap-2">
                <div
                  className={`w-8 h-8 md:w-10 md:h-10 rounded flex items-center justify-center ${stat?.bgColor}`}
                >
                  <Icon name={stat?.icon} size={18} color={stat?.color} />
                </div>
                <span className="text-xs md:text-sm text-muted-foreground">
                  {stat?.label}
                </span>
              </div>
            </div>
            <div className="flex items-end justify-between">
              <span className="text-2xl md:text-3xl lg:text-4xl font-bold text-foreground">
                {stat?.value}
              </span>
              <span className="text-xs text-muted-foreground">
                {stat?.description}
              </span>
            </div>
          </div>
        ))}
      </div>
      <div className="bg-muted rounded-lg p-3 md:p-4 flex items-center gap-2">
        <Icon name="Clock" size={16} color="var(--color-muted-foreground)" />
        <span className="text-xs md:text-sm text-muted-foreground">
          Last updated: {lastUpdated}
        </span>
      </div>
    </div>
  );
};

export default MobileStats;